import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ContentTile from 'components/atoms/layout/ContentTile';
import NavIcon from 'components/molecules/home/NavIcon';

// Wrapping the whole NavCard in an anchor tag (to handle external links)
// and unsetting the default anchor tag styles
const NavCardLink = styled.a`
    color: unset;
    margin: 0 0 30px;
    flex: 0 0 95%;
    
    @media only screen and (min-width: 1200px) {
        margin: 0 15px 30px;
        flex: 0 0 ${props => (props.cardCount <= 4 ? '33' : '25')}vw; // 33 & 25 are breaking points for dynamic card layout
    }

    &:hover {
        text-decoration: none;
    }
`;

const NavContentTile = styled(ContentTile)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 10px 8px;
    background: #FFF;
    border: none;
    cursor: pointer;
    margin: 0 0 35px;
    border-radius: 8px;

    &:hover {
        box-shadow: 3px 3px 10px 0 rgba(0,0,0,0.25);
    }

    transition: border .3s, box-shadow .7s;

    @media only screen and (max-width: 1200px) {
        height: fit-content;
        margin-bottom: 0px;
    }
`;

const Text = styled.span`
    font-size: 16px;
    width: 100%;
    text-align: center;
    color: ${props => props.theme.colors.chinchilla};

    @media only screen and (max-width: 1200px) {
        margin-bottom: 8px;
    }
`;

const AppTitle = styled(Text)`
    font-size: 24px;
    text-transform: uppercase;
    color: ${props => props.theme.colors.chinchilla};

    a:hover & {
    color: ${props => props.theme.colors.lochmara};
    }

    transition: color .3s;
    margin: 5px 0;

    @media only screen and (min-width: 1200px) {
        margin: 20px 0 5px;
    }
`;

const NavigationCard = props => (
    <NavCardLink href={props.linkURL || null} target={props.newWindow ? '_blank' : null} cardCount={props.cardCount}>
        <NavContentTile onClick={props.clickAction || null}>
            <NavIcon iconColor={props.iconColor} iconName={props.iconName} />
            <AppTitle>
                {props.title}
            </AppTitle>
            <Text>
                {props.description}
            </Text>
        </NavContentTile>
    </NavCardLink>
);


NavigationCard.propTypes = {
    cardCount: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    clickAction: PropTypes.func,
    linkURL: PropTypes.string,
    newWindow: PropTypes.bool
};

export default NavigationCard;



// WEBPACK FOOTER //
// ./src/components/organisms/home/NavigationCard.js